import React, { useState } from 'react';

import LetUsCallYouModal from '@components/ui/LetUsCallYou/LetUsCallYouModal';
import useCallMeFrom from '@components/views/hooks/useCallMeFrom';
import { ApiError } from '@api/index';
import { useToggle } from '@hooks/common';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

import { LetUsCallYouProps } from './types';
import SuccessModal from '../modals/SuccessModal';

const LetUsCallYou = ({
  visibleLetUsCallYouModal,
  entityId,
  entityName,
  price,
  currency,
  salesItemType,
  availabilityStatus,
  onClose,
  formCheckInDate,
  formCheckOutDate,
  hotelRoomList,
  onFormSendSuccess,
  alertType,
  token,
  hideCloseIcon,
  preventBodyScroll,
  channel = 201,
  showSuccessModal = true,
}: LetUsCallYouProps) => {
  const [isErrorMsg, setIsErrorMsg] = useState('');
  const [visibleSuccessModal, toggleVisibleSuccessModal] = useToggle(false);

  const {
    onSubmit,
    isPostCallMeLoading,
    error: isPostCallMeError,
    isPostCallMeSuccess,
  } = useCallMeFrom({
    entityId,
    entityName,
    price,
    currency,
    salesItemType,
    availabilityStatus,
    formCheckInDate,
    formCheckOutDate,
    hotelRoomList,
    onClose,
    onFormSendSuccess,
    token,
    channel,
    setErrorMsg: setIsErrorMsg,
  });

  useSkipEffectOnMount(() => {
    if (isPostCallMeSuccess) {
      toggleVisibleSuccessModal();
      setIsErrorMsg('');
    }
  }, [isPostCallMeSuccess]);

  return (
    <>
      {visibleLetUsCallYouModal && (
        <LetUsCallYouModal
          isPostCallMeError={(isPostCallMeError as ApiError)?.body?.errors}
          onSubmit={onSubmit}
          onCancel={() => {
            setIsErrorMsg('');
            onClose();
          }}
          errorMessage={isErrorMsg}
          entityName={entityName}
          formCheckInDate={formCheckInDate}
          formCheckOutDate={formCheckOutDate}
          isPostCallMeLoading={isPostCallMeLoading}
          alertType={alertType}
          hideCloseIcon={hideCloseIcon}
          preventBodyScroll={preventBodyScroll}
        />
      )}

      {showSuccessModal && visibleSuccessModal ? (
        <SuccessModal
          title='Talebiniz alınmıştır. En kısa sürede satış danışmanımız tarafından aranacaksınız.'
          contentStyle={{ marginTop: 30 }}
          onCancel={() => toggleVisibleSuccessModal()}
        />
      ) : null}
    </>
  );
};

export default LetUsCallYou;
